/* global CurrencySymbol */

import {connect} from 'react-redux';
import classNames from 'classnames';

import {dateChange} from '../../../general/actionCreators';

const DateItem = ({available, title, onClick}) => (
    <li className={classNames({available})} onClick={onClick}>
        {`${available ? '' : CurrencySymbol} ${title}`}
    </li>
);

const mapDispatchToProps = (dispatch, {offset}) => ({
    onClick: () => dispatch(dateChange(offset)),
});

export default connect(undefined, mapDispatchToProps)(DateItem);
